import React from "react";
import { Form } from "react-bootstrap";

const StatusFilter = ({ body, setBody, statusFilterOptionArr, type }) => {
  const isBooking = type === "booking";
  const field = isBooking ? "status" : "status";

  const handleChange = (e) => {
    const { value } = e.target;
    setBody((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Form.Select
      className="select text-muted"
      aria-label="Status filter"
      value={body[field] || ""}
      onChange={handleChange}
    >
      {statusFilterOptionArr?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default StatusFilter;
